"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _SelectSearch = _interopRequireDefault(require("../SelectSearch"));
var _excluded = ["className", "options", "onChange", "selected", "defaultValue", "dynamic"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/InputSelect/index.js";
var noop = function noop() {};
var defaultProps = {
  defaultValue: '',
  selected: -1,
  onChange: noop,
  options: []
};

// map the options
function map(option) {
  if (typeof option === 'string') {
    return {
      label: option,
      value: option
    };
  }
  return option;
}
function InputSelect(_ref) {
  var className = _ref.className,
    options = _ref.options,
    onChange = _ref.onChange,
    selected = _ref.selected,
    defaultValue = _ref.defaultValue,
    dynamic = _ref.dynamic,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  function change(option) {
    setValue(option);
    onChange(option.value);
  }
  function onSearch(text) {
    if (dynamic) {
      onChange(text);
    }
  }
  function onClickClear() {
    onChange("");
    setValue({
      label: "",
      value: ""
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_SelectSearch["default"], Object.assign({
    focus: dynamic,
    value: value || map(defaultValue),
    className: className,
    options: options.map(map),
    onChange: change,
    onSearch: onSearch,
    onClickClear: onClickClear
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 13
    }
  }));
}
InputSelect.defaultProps = defaultProps;
var _default = exports["default"] = InputSelect;